import React from 'react';
import classes from './classes.module.scss';
import { SvgIcon } from '../../../../common/sprites';

export const reviewItemThemes = {
  advisorHeader: 'reviewItemAdvisorHeader',
  reviewsSection: 'reviewItemReviewsSection'
};

function ReviewItem({
  isPositive = false,
  value = 0,
  ignoreLeftMargin = false,
  theme = reviewItemThemes.reviewsSection
}) {
  return (
    <div data-testid={ `header-${ isPositive ? 'likes' : 'dislikes' }-count` } className={ classes[theme] } style={ ignoreLeftMargin ? { marginLeft: 0 } : {} } suppressHydrationWarning>
      <div className={ classes.reviewItem } suppressHydrationWarning>
        <SvgIcon className={ classes.reviewImg } id={ isPositive ? 'rate_positive' : 'rate_negative' } />
        { value }
      </div>
    </div>
  );
}

export default ReviewItem;
